import { createRouter, createWebHistory } from 'vue-router';
import { i18n } from './main.js'; // Import the i18n instance
import { routeGuard } from './routeGuards';

// import Home from './Pages/Home/HomePage.vue';
import Home from './Pages/Login/Home.vue';
import FAQ from './Pages/FAQ/FAQ.vue';
import PreProgram from './Pages/Home/Homepagecomponents/PreProgram.vue';
import PostProgram from './Pages/Home/Homepagecomponents/PostProgram.vue';
const routes = [
  {
    path: '/',
    redirect: '/Home',
  },
  {
    path: '/Home',
    name: 'Home',
    component: Home, // This is your Login page
    meta: { titleKey: 'Home' },
  },
  {
    path: '/FAQ',
    name: 'FAQ',
    component: FAQ,
    meta: { titleKey: 'FAQ' },
  },
  {
    path: '/PreProgram',
    name: 'PreProgram',
    component: PreProgram,
    meta: { titleKey: 'PreProgram' },

  },
  {
    path: '/PostProgram',
    name: 'PostProgram',
    component: PostProgram,
    meta: { titleKey: 'PostProgram' },
  },
  // Remove this block if you don't want /Login as a separate route:
  // {
  //   path: '/Login',
  //   name: 'Login',
  //   component: Home,
  //   meta: { titleKey: 'Login' },
  // },
  { path: '/:notFound(.*)', redirect: '/Home' },
];

// Create the router
const router = createRouter({
  linkActiveClass: 'active',
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

// Dynamically set page title based on route
router.beforeEach((to, from, next) => {

  const pageTitleKey = to.meta.titleKey; // Access the title key
  if (pageTitleKey) {
    const translatedTitle = i18n.global.t(`titles.${pageTitleKey}`); // Fetch translated title using i18n
    document.title = translatedTitle || 'Default Title'; // Set the page title dynamically
  }
  next();
});

router.beforeEach(routeGuard);

export default router;
